export default "__VITE_ASSET__a4ef3881__"